<template>
    <trax-ui-top-box :background-image="phase.meta.background" 
        :icon="learning_unit_icons[item.type]" :title1="item.code" 
        :title2="phase.name" :title3="registration.program.name" 
        :description-title="item.name" 
        :description="item.description" description-toggle="1" description-hidden="1"
        :button-icon="buttonIcon" :button-name="buttonName" :button-handler="buttonHandler" 
        :link1="group" >
    </trax-ui-top-box>
</template>

<script>
    export default {

        props: {
            editButton: null,
            viewButton: null,
        },

        data: function() {
            return {
                lang: lang,
                state: data.state,
                user: user,
                registration: data.registration,
                phase: data.phase,
                item: data.item,
                learning_unit_dashboard_routes: data.learning_unit_dashboard_routes,
                learning_unit_icons: data.learning_unit_icons
            }
        },

        computed: {

            buttonIcon: function() {
                if (this.viewButton) return 'bar_chart';
                if (this.editButton && this.editDashboardPermission && this.stateAllowsEdition) return 'edit';
            },

            buttonName: function() {
                if (this.viewButton) return this.lang.polaris.dashboard.display;
                if (this.editButton && this.editDashboardPermission && this.stateAllowsEdition) return this.lang.polaris.form.edit;
            },

            buttonHandler: function() {
                if (this.viewButton) return this.viewHandler;
                if (this.editButton && this.editDashboardPermission && this.stateAllowsEdition) return this.editHandler;
            },

            stateAllowsEdition: function() {
                // An archived registration is closed: its sheets are read-only.
                if (this.registration.status == 'archived') {
                    return false;
                }
                return !this.stateValidated;
            },

            stateValidated: function() {
                return this.state && this.state.validation;
            },

            editDashboardPermission: function() {
                return this.user.admin || this.user.permissions['dashboard.write-all'] || this.user.permissions['dashboard.write-mine-locations'];
            },

            group: function() {
                return {value: this.registration.cohort.name, icon: 'people'};
            }
        },

        methods: {

            editHandler: function() {
                var routes = this.learning_unit_dashboard_routes;
                var href = routes[this.item.type]+'/registration/'+this.registration.id+'/'+this.item.type+'/'+this.item.id+'/edit';
                window.location = href;
            },

            viewHandler: function() {
                var routes = this.learning_unit_dashboard_routes;
                var href = routes[this.item.type]+'/registration/'+this.registration.id+'/'+this.item.type+'/'+this.item.id;
                window.location = href;
            }
        }
    }
</script>
